import {IPortalseite} from "./Interfaces";
import Veraportal from "./Veraportal";

export default class Startseite extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {

        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {

        return true;
    }
}